import React, { useState, useEffect } from 'react';
import HeaderOne from "../components/HeaderTwo";
import BottomFooter from "../components/BottomFooter";

const Testimonials = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchTestimonials();
    }, []);

    const fetchTestimonials = async () => {
        try {
            console.log('Fetching testimonials from API...');
            const response = await fetch(`${process.env.REACT_APP_API_URL}/testimonials/`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });

            console.log('Response status:', response.status);

            if (!response.ok) {
                throw new Error(`Failed to fetch testimonials: ${response.status}`);
            }

            const data = await response.json();
            console.log('Fetched testimonials:', data);

            setTestimonials(data);
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);
            console.error('Error fetching testimonials:', err);
        }
    };

    const renderStars = (rating) => {
        return [...Array(5)].map((_, index) => (
            <span key={index} style={{ color: "#FBBF24", fontSize: "1.2rem", marginRight: "2px" }}>
                {index < rating ? "★" : "☆"}
            </span>
        ));
    };

    const renderTestimonialCard = (testimonial) => (
        <div
            key={testimonial.id}
            className="testimonial-card"
            style={{
                backgroundColor: "#FFFFFF",
                borderRadius: "24px",
                padding: "32px",
                border: "1px solid #E2E8F0",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s ease",
                marginBottom: "24px",
                height: "100%",
                display: "flex",
                flexDirection: "column"
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = "0 20px 40px rgba(0, 0, 0, 0.1)";
                e.currentTarget.style.borderColor = "#CBD5E1";
                e.currentTarget.style.transform = "translateY(-4px)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0, 0, 0, 0.05)";
                e.currentTarget.style.borderColor = "#E2E8F0";
                e.currentTarget.style.transform = "translateY(0)";
            }}
        >
            <div
                className="testimonial-header"
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "20px",
                    paddingBottom: "20px",
                    borderBottom: "1px solid #F1F5F9"
                }}
            >
                <div
                    className="avatar"
                    style={{
                        width: "56px",
                        height: "56px",
                        borderRadius: "50%",
                        backgroundColor: "#F1F5F9",
                        color: "#1D2A3A",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "1.3rem",
                        fontWeight: "600",
                        marginRight: "16px",
                        flexShrink: 0,
                        border: "1px solid #E2E8F0"
                    }}
                >
                    {testimonial.avatar_initials}
                </div>
                <div className="testimonial-info" style={{ flex: 1 }}>
                    <h3
                        className="customer-name"
                        style={{
                            margin: "0 0 4px 0",
                            fontSize: "1.25rem",
                            fontWeight: "700",
                            color: "#1A1A1A"
                        }}
                    >
                        {testimonial.name}
                    </h3>
                    <p
                        className="time-ago"
                        style={{
                            margin: "0",
                            fontSize: "0.85rem",
                            color: "#64748B",
                            fontWeight: "500"
                        }}
                    >
                        {testimonial.time_ago}
                    </p>
                </div>
            </div>
            <div className="testimonial-body">
                <div
                    className="stars"
                    style={{
                        marginBottom: "16px",
                        fontSize: "1.1rem"
                    }}
                >
                    {renderStars(testimonial.rating)}
                </div>
                <p
                    className="review-text"
                    style={{
                        margin: "0",
                        lineHeight: "1.8",
                        color: "#4B5563",
                        fontSize: "1.05rem",
                        fontWeight: "700"
                    }}
                >
                    {testimonial.review}
                </p>
            </div>
        </div>
    );

    if (loading) {
        return (
            <>
                <HeaderOne />
                <div style={{
                    textAlign: "center",
                    padding: "50px",
                    color: "#8A7F8D",
                    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    backgroundColor: "#FAF9F6",
                    minHeight: "400px"
                }}>
                    <p style={{ fontSize: "1.2rem" }}>Loading testimonials...</p>
                </div>
                <BottomFooter />
            </>
        );
    }

    if (error) {
        return (
            <>
                <HeaderOne />
                <div style={{
                    textAlign: "center",
                    padding: "50px",
                    color: "#EFD1D4",
                    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    backgroundColor: "#EFD1D4",
                    minHeight: "400px"
                }}>
                    <p style={{ fontSize: "1.2rem" }}>Failed to load testimonials: {error}</p>
                </div>
                <BottomFooter />
            </>
        );
    }

    return (
        <>
            <HeaderOne />

            <div className="testimonials-container" style={{ fontFamily: "'Inter', sans-serif", backgroundColor: "#FFFFFF" }}>
                {/* Hero Section - Updated to match About Us theme */}
                <section
                    className="testimonials-hero"
                    style={{
                        background: "linear-gradient(135deg, #1D2A3A 0%, #2C3E50 100%)",
                        color: "white",
                        padding: "80px 20px",
                        textAlign: "center",
                        marginBottom: "40px",
                        position: "relative",
                        overflow: "hidden"
                    }}
                >
                    <div className="hero-glow" style={{
                        position: "absolute",
                        top: "-50%",
                        left: "-20%",
                        width: "140%",
                        height: "200%",
                        background: "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
                        pointerEvents: "none"
                    }}></div>
                    <div
                        className="testimonials-hero-content"
                        style={{ maxWidth: "1000px", margin: "0 auto", position: "relative", zIndex: 1 }}
                    >
                        <h1
                            className="testimonials-title"
                            style={{
                                fontSize: "clamp(2.5rem, 5vw, 4rem)",
                                fontWeight: "800",
                                marginBottom: "20px",
                                color: "white",
                                textShadow: "0 2px 10px rgba(0,0,0,0.1)"
                            }}
                        >
                            Customer Testimonials
                        </h1>
                        <p
                            className="testimonials-subtitle"
                            style={{
                                fontSize: "1.25rem",
                                opacity: "0.95",
                                lineHeight: "1.6",
                                color: "white",
                                maxWidth: "700px",
                                margin: "0 auto"
                            }}
                        >
                            Here is what some of our customers have had to say about our printing services
                        </p>
                    </div>
                </section>

                <div
                    className="testimonials-container-inner"
                    style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px 80px" }}
                >
                    {/* Section Title - Updated to match About Us style */}
                    <section
                        className="testimonials-section"
                        style={{ marginBottom: "40px" }}
                    >
                        <h2
                            className="testimonials-section-title"
                            style={{
                                color: "#1A1A1A",
                                fontSize: "2.2rem",
                                marginBottom: "40px",
                                fontWeight: "700",
                                display: "flex",
                                alignItems: "center",
                                gap: "15px"
                            }}
                        >
                            <span style={{ width: "40px", height: "4px", backgroundColor: "#1D2A3A", borderRadius: "2px" }}></span>
                            What Our Customers Say
                        </h2>

                        {testimonials.length === 0 ? (
                            <div
                                style={{
                                    backgroundColor: "#FFFFFF",
                                    borderRadius: "16px",
                                    padding: "40px",
                                    textAlign: "center",
                                    border: "2px solid #E0DBE6",
                                    boxShadow: "0 4px 20px rgba(138, 127, 141, 0.06)"
                                }}
                            >
                                <p style={{
                                    color: "#7A6F8B",
                                    fontSize: "1.2rem",
                                    margin: 0
                                }}>
                                    No testimonials available at the moment.
                                </p>
                            </div>
                        ) : (
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
                                gap: "24px",
                                marginTop: "20px"
                            }}>
                                {testimonials.map(testimonial => renderTestimonialCard(testimonial))}
                            </div>
                        )}
                    </section>

                    {/* Stats Section - Optional but matches About Us structure */}
                    {testimonials.length > 0 && (
                        <section
                            className="testimonials-stats"
                            style={{
                                marginTop: "60px",
                                backgroundColor: "#FFFFFF",
                                borderRadius: "24px",
                                padding: "48px 40px",
                                border: "1px solid #E2E8F0",
                                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)"
                            }}
                        >
                            <h3
                                style={{
                                    color: "#1A1A1A",
                                    fontSize: "1.6rem",
                                    marginBottom: "40px",
                                    textAlign: "center",
                                    fontWeight: "700",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "15px"
                                }}
                            >
                                <span style={{ width: "30px", height: "3px", backgroundColor: "#1D2A3A", borderRadius: "2px" }}></span>
                                Our Customer Satisfaction
                                <span style={{ width: "30px", height: "3px", backgroundColor: "#1D2A3A", borderRadius: "2px" }}></span>
                            </h3>
                            <div style={{
                                display: "flex",
                                justifyContent: "space-around",
                                flexWrap: "wrap",
                                gap: "32px"
                            }}>
                                <div style={{ textAlign: "center", flex: "1", minWidth: "150px" }}>
                                    <div style={{
                                        fontSize: "3rem",
                                        color: "#1D2A3A",
                                        fontWeight: "800",
                                        marginBottom: "8px"
                                    }}>
                                        {testimonials.length}
                                    </div>
                                    <div style={{
                                        color: "#64748B",
                                        fontSize: "1.1rem",
                                        fontWeight: "600"
                                    }}>
                                        Total Reviews
                                    </div>
                                </div>
                                <div style={{ textAlign: "center", flex: "1", minWidth: "150px" }}>
                                    <div style={{
                                        fontSize: "3rem",
                                        color: "#059669",
                                        fontWeight: "800",
                                        marginBottom: "8px"
                                    }}>
                                        {testimonials.length > 0
                                            ? (testimonials.reduce((acc, t) => acc + t.rating, 0) / testimonials.length).toFixed(1)
                                            : "0.0"
                                        }
                                    </div>
                                    <div style={{
                                        color: "#64748B",
                                        fontSize: "1.1rem",
                                        fontWeight: "600"
                                    }}>
                                        Average Rating
                                    </div>
                                </div>
                                <div style={{ textAlign: "center", flex: "1", minWidth: "150px" }}>
                                    <div style={{
                                        fontSize: "3rem",
                                        color: "#3b82f6",
                                        fontWeight: "800",
                                        marginBottom: "8px"
                                    }}>
                                        {testimonials.filter(t => t.rating >= 4).length}
                                    </div>
                                    <div style={{
                                        color: "#64748B",
                                        fontSize: "1.1rem",
                                        fontWeight: "600"
                                    }}>
                                        4+ Star Reviews
                                    </div>
                                </div>
                            </div>
                        </section>
                    )}
                </div>
            </div>

            <BottomFooter />
        </>
    );
};

export default Testimonials;